
// 处理将世界地图移位为以太平洋为中心，美国和俄罗斯label位置不对的bug
var geoCoordMap = {
  'United States': [80, 38],
  'United States of America': [80, 38]
};

function _default(mapType, region) {
  if (mapType === 'world') {
    var geoCoord = geoCoordMap[region.name];

    if (geoCoord) {
      var cp = region.center;
      cp[0] = geoCoord[0];
      cp[1] = geoCoord[1];
    }
  }
}

module.exports = _default;
